import React from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../images/logo.png";
import { cartPage, homePage } from "../redux/route/actions";

const Navbar = () => {
  const { cart } = useSelector((state) => state.shopping);

  const totalCart = cart.reduce((acc, item) => acc + item.quantity, 0);
  const dispatch = useDispatch();
  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <button onClick={() => dispatch(homePage())}>
          <img src={logo} alt="LWS" className="max-w-[140px]" />
        </button>
        <div className="flex gap-4">
          <button
            className="navHome"
            id="lws-home"
            onClick={() => dispatch(homePage())}
          >
            Home
          </button>
          <button
            className="navCart"
            id="lws-cart"
            onClick={() => dispatch(cartPage())}
          >
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping" />
            <span id="lws-totalCart">{totalCart}</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
